<!-- src/components/ezer/EzerSuggestions.vue -->
<template>
  <div class="ezer-suggestions" v-if="hasSuggestions">
    <button
      v-for="s in combined"
      :key="s.text"
      class="ezer-chip"
      :class="s.type === 'question' ? 'ezer-chip--question' : 'ezer-chip--action'"
      @click="$emit('send', s.text)"
    >{{ s.text }}</button>
  </div>
</template>

<script>
import { computed } from 'vue'
export default {
  name: 'EzerSuggestions',
  props: { suggestions: Object },
  emits: ['send'],
  setup(props) {
    const combined = computed(() => {
      const items = []
      // Show max 2 questions + 1 action as inline chips
      const qs = (props.suggestions?.questions || []).slice(0, 2)
      const acts = (props.suggestions?.actions || []).slice(0, 1)
      qs.forEach(q => items.push({ text: q, type: 'question' }))
      acts.forEach(a => items.push({ text: a, type: 'action' }))
      return items
    })
    const hasSuggestions = computed(() => combined.value.length > 0)
    return { combined, hasSuggestions }
  },
}
</script>
